import VueI18n from '@/i18n';
import { createObjectInOfferDetailsRoute } from '@/router/utils';
import { handleTranslations, } from '@/layouts/_components/Notifications/_util/notification-factory';
export const handleObjectStatusChangedNotification = (notification) => {
    const { type, payload: { brand, object, objectType, offer, type: acceptType }, } = notification;
    return {
        getTranslations() {
            const translationPlaceholders = {
                ...object,
                type: VueI18n.t(`notifications.${acceptType}`),
            };
            return handleTranslations(type, translationPlaceholders);
        },
        getRoute() {
            return createObjectInOfferDetailsRoute(brand.id, object.id, objectType.id, offer.id);
        },
    };
};
